import React from "react";
import MuiMenu from "@mui/material/Menu";
import PropTypes from "prop-types";

/**
 * Menu component wrapper for dropdown menus.
 * Wraps Material-UI Menu with theme integration.
 * 
 * @component
 * @example
 * <Menu
 *   anchorEl={anchorEl}
 *   open={Boolean(anchorEl)}
 *   onClose={handleClose}
 * >
 *   <MenuItem onClick={handleClose}>Profile</MenuItem>
 * </Menu>
 */
const Menu = ({ children, ...props }) => {
  return <MuiMenu {...props}>{children}</MuiMenu>;
};

Menu.propTypes = {
  /**
   * The content of the component, normally MenuItem
   */
  children: PropTypes.node,
  /**
   * An HTML element, or a function that returns one
   */
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  /**
   * This is the point on the anchor where the popover's anchorEl will attach to
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.oneOf(["left", "center", "right"]),
    ]),
    vertical: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.oneOf(["top", "center", "bottom"]),
    ]),
  }),
  /**
   * If true, the component is shown
   */
  open: PropTypes.bool.isRequired,
  /**
   * Callback fired when the component requests to be closed
   */
  onClose: PropTypes.func,
  /**
   * Props applied to the Menu element
   */
  MenuListProps: PropTypes.object,
  /**
   * This is the point on the popover which will attach to the anchor's origin
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.oneOf(["left", "center", "right"]),
    ]),
    vertical: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.oneOf(["top", "center", "bottom"]),
    ]),
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Menu behavior

export default Menu;

